import { useState, useEffect } from "react";
import { useTournamentResultsEnhanced } from "./useTournamentResultsEnhanced";
import { buildPrizeBreakdown } from "../utility/prizeBreakdown";
import { stripResultPrizes } from "../utils/prizeSnapshot";
import {
  sanitizeErrorMessage,
  logErrorForDebugging,
} from "../utility/errorSanitization";

export const usePrizeBreakdown = (tournamentId) => {
  const [prizeBreakdown, setPrizeBreakdown] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const {
    results,
    tournament,
    loading: resultsLoading,
    isUpdating,
    error: resultsError,
    updateError,
    refetch,
  } = useTournamentResultsEnhanced(tournamentId, null, false, {
    cacheOnly: true,
  });

  useEffect(() => {
    if (!results || results.length === 0) {
      setPrizeBreakdown([]);
      setLoading(false);
      return;
    }

    try {
      setLoading(true);
      const rows = tournament?.isResultsFinalized
        ? results
        : stripResultPrizes(results);
      setPrizeBreakdown(buildPrizeBreakdown(rows));
      setLoading(false);
    } catch (err) {
      const sanitizedMessage = sanitizeErrorMessage(
        err,
        "process prize breakdown"
      );
      logErrorForDebugging(err, "process prize breakdown", sanitizedMessage);
      setError(sanitizedMessage);
      setLoading(false);
    }
  }, [results, tournament?.isResultsFinalized]);

  const isActuallyLoading =
    resultsLoading ||
    loading ||
    (!prizeBreakdown && results && results.length > 0);

  return {
    prizeBreakdown,
    loading: isActuallyLoading,
    isUpdating,
    isPayoutFinalized: Boolean(tournament?.isPayoutFinalized),
    isResultsFinalized: Boolean(tournament?.isResultsFinalized),
    error: error || resultsError,
    updateError,
    refetch,
    results,
    tournament,
  };
};
